/*
 * @Author: N0ts
 * @Date: 2023-03-07 16:58:59
 * @Description: config
 * @FilePath: /chat-gpt/src/config/config.ts
 * @Mail：mail@n0ts.top
 */

export default {
    proxyHttp: 'https://api-gpt.mvtchat.com',
    key: "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",
    data: {
        model: "gpt-3.5-turbo"
    },
    system: "",
    max_token: 4096
};
